export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  author: string;
  authorAvatar: string;
  date: string;
  readTime: string;
  tags: string[];
  featured: boolean;
}

export const categories = [
  { slug: 'jingdian-shenshi', name: '经典绅士', description: '西装、衬衫、领带等经典绅士穿搭指南', icon: 'ri-men-line' },
  { slug: 'fugu-dapei', name: '复古搭配', description: '复古风格男装搭配技巧与灵感', icon: 'ri-vip-crown-line' },
  { slug: 'xiuxian-riang', name: '休闲日常', description: '成熟男士日常休闲穿搭方案', icon: 'ri-shirt-line' },
  { slug: 'peishi-tuijian', name: '配饰推荐', description: '手表、眼镜、皮具等男士配饰精选', icon: 'ri-vip-diamond-line' },
  { slug: 'shenghuo-meixue', name: '生活美学', description: '品酒、雪茄、家居等成熟男士生活艺术', icon: 'ri-goblet-line' },
  { slug: 'hufa-jiankang', name: '护肤健康', description: '男士护肤、健身与健康生活指南', icon: 'ri-heart-pulse-line' },
];

export const articles: Article[] = [
  {
    slug: 'shenshi-zhuangban-xuanze-zhinan',
    title: '成熟男士西装选择完全指南：从面料到剪裁的全面解析',
    excerpt: '一套合身的西装是成熟男性衣橱中最重要的投资。本文从面料选择、剪裁款式、颜色搭配等多个维度，为您详细解析如何挑选最适合自己的绅士西装。',
    content: `<p>对于每一位成熟男性而言，一套得体的西装不仅仅是一件衣服，更是身份与品位的象征。无论是在重要商务场合、正式晚宴，还是婚礼庆典，合适的西装都能让您举手投足间散发自信魅力。</p>
<h2>一、面料的选择艺术</h2>
<p>西装面料的优劣直接决定了穿着体验和整体质感。优质羊毛面料是最经典的选择，其中以美利奴羊毛最为常见。它的纤维细腻柔软，具有良好的透气性和回弹性，穿着舒适且不易起皱。</p>
<p>对于春夏季节，可以选择轻薄的法兰绒或马海毛混纺面料。马海毛具有天然的光泽感，能够为您增添一抹低调的奢华。而在秋冬季节，厚实的粗花呢和羊绒面料不仅保暖效果出色，更散发着浓郁的英伦绅士气息。</p>
<h2>二、剪裁款式的选择</h2>
<p>成熟男士的西装剪裁应当以经典为基调，避免过于紧身或过度宽松的款式。英式剪裁注重肩部线条和腰部收束，能够很好地修饰体型；意式剪裁则更加柔软自然，适合追求舒适感的绅士。</p>
<p>双排扣西装是成熟男性的绝佳选择，它不仅能够拉长身形比例，更展现出一种从容不迫的权威感。单排两粒扣则是最为百搭的款式，适用于绝大多数场合。</p>
<h2>三、经典颜色搭配</h2>
<p>深灰色和藏青色是最为经典的两款西装颜色，它们既稳重又不失精致。深灰色西装搭配白色衬衫和酒红色领带，是商务场合的不败之选。藏青色西装则可以选择浅蓝色衬衫和深棕色皮鞋，营造出干练利落的形象。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sophisticated%20mature%20man%20wearing%20a%20perfectly%20tailored%20charcoal%20grey%20suit%20with%20white%20shirt%20and%20burgundy%20tie%2C%20standing%20in%20a%20luxurious%20classic%20study%20room%20with%20wooden%20bookshelves%20and%20warm%20ambient%20lighting%2C%20editorial%20fashion%20photography%20with%20soft%20shadows%20and%20refined%20aesthetic&width=1200&height=800&seq=article-suit-guide&orientation=landscape',
    category: '经典绅士',
    categorySlug: 'jingdian-shenshi',
    author: '王志远',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20distinguished%20Chinese%20man%20in%20his%2040s%20wearing%20a%20navy%20blazer%2C%20warm%20friendly%20expression%2C%20studio%20portrait%20with%20cream%20background%2C%20soft%20even%20lighting&width=200&height=200&seq=avatar-wang&orientation=squarish',
    date: '2026-08-05',
    readTime: '8分钟',
    tags: ['西装', '绅士穿搭', '商务着装', '面料选择', '剪裁指南'],
    featured: true,
  },
  {
    slug: 'fugu-nanzhuang-fanrong-qushi',
    title: '2026秋冬复古男装趋势：经典元素与现代审美的完美融合',
    excerpt: '复古风潮在男装界持续升温。今年秋冬，哪些经典元素重新回归？如何将复古单品与现代穿搭完美结合？让我们一起探索复古男装的魅力世界。',
    content: `<p>复古风格在男装领域从未真正离开，而在2026年的秋冬季节，它将以更加精致的姿态回归。对于成熟男性而言，复古穿搭不仅是对经典的致敬，更是一种彰显深厚品味的方式。</p>
<h2>一、灯芯绒的华丽回归</h2>
<p>灯芯绒面料在今年秋冬强势回归，成为复古穿搭的核心元素。选择一件深棕色或橄榄绿色的灯芯绒西装外套，搭配一条同色系的羊毛西裤，内搭一件高领毛衣，便能轻松打造出温暖而不失格调的秋冬造型。</p>
<h2>二、高腰裤的经典魅力</h2>
<p>高腰裤是复古风格的标志性单品，它能够有效拉长腿部线条，塑造出优雅的身形比例。选择羊毛混纺或厚棉质的高腰裤，搭配一件合身的针织衫和经典的乐福鞋，既舒适又充满老派绅士的韵味。</p>
<h2>三、复古配饰的点睛之笔</h2>
<p>一条复古花纹的领带、一块经典机械手表、一副玳瑁色眼镜框，这些细节往往是复古穿搭中最出彩的部分。选择配饰时，建议以棕色系和金色系为主调，它们能为整体造型增添温暖而高级的质感。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stylish%20mature%20man%20wearing%20corduroy%20brown%20sport%20coat%20with%20cream%20turtleneck%20sweater%2C%20walking%20through%20autumn%20leaves%20in%20a%20picturesque%20city%20street%2C%20warm%20golden%20hour%20light%2C%20editorial%20fashion%20photography%20with%20nostalgic%20aesthetic&width=1200&height=800&seq=article-vintage-trend&orientation=landscape',
    category: '复古搭配',
    categorySlug: 'fugu-dapei',
    author: '陈建民',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20stylish%20Chinese%20man%20in%20his%2030s%20with%20tortoiseshell%20glasses%2C%20wearing%20a%20brown%20leather%20jacket%2C%20confident%20smile%2C%20studio%20portrait%20with%20warm%20neutral%20background&width=200&height=200&seq=avatar-chen&orientation=squarish',
    date: '2026-08-03',
    readTime: '6分钟',
    tags: ['复古男装', '秋冬趋势', '灯芯绒', '高腰裤', '绅士风格'],
    featured: true,
  },
  {
    slug: 'zhongnian-nanshi-xiuxian-zhoumo',
    title: '中年男士周末休闲穿搭：舒适与品味的完美平衡',
    excerpt: '周末休闲时光不是放弃品味的理由。如何在不失舒适感的同时，依然保持成熟男士应有的格调？这里有几套实用又时髦的周末穿搭方案。',
    content: `<p>周末是放松身心的时刻，但这并不意味着可以忽视个人形象。对于成熟男士来说，周末休闲穿搭的关键在于找到舒适与品味的平衡点。</p>
<h2>一、针织衫的温暖魅力</h2>
<p>一件质地优良的羊绒或美利奴羊毛针织衫是秋冬周末的完美之选。选择驼色、灰色或深蓝色等经典色调，搭配一条剪裁得体的休闲裤和一双皮质乐福鞋，既舒适又不失优雅。</p>
<h2>二、休闲夹克的百搭法则</h2>
<p>一件哈灵顿夹克或飞行员夹克能够为整体造型增添几分活力。深绿色或棕色是最为百搭的颜色选择。内搭一件纯色T恤或牛津纺衬衫，下身搭配深色牛仔裤和白色运动鞋，轻松打造出周末休闲造型。</p>
<h2>三、配饰让造型更出彩</h2>
<p>一条优质的羊绒围巾、一副复古太阳镜、一个皮质手提包，这些细节能让您的周末穿搭更上一个台阶。记住，休闲不等于随便，精致的生活态度应当贯穿每一天。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20refined%20mature%20man%20wearing%20cashmere%20sweater%20in%20camel%20color%20and%20tailored%20chinos%2C%20sitting%20at%20a%20stylish%20outdoor%20cafe%20in%20autumn%2C%20warm%20sunlight%20filtering%20through%20trees%2C%20relaxed%20yet%20elegant%20atmosphere%2C%20editorial%20photography&width=1200&height=800&seq=article-casual-weekend&orientation=landscape',
    category: '休闲日常',
    categorySlug: 'xiuxian-riang',
    author: '李博文',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20friendly%20Chinese%20man%20in%20his%2040s%20with%20salt%20and%20pepper%20hair%2C%20wearing%20a%20casual%20linen%20shirt%2C%20warm%20smile%2C%20outdoor%20portrait%20with%20soft%20natural%20light&width=200&height=200&seq=avatar-li&orientation=squarish',
    date: '2026-07-28',
    readTime: '5分钟',
    tags: ['休闲穿搭', '周末造型', '针织衫', '休闲夹克', '中年男士'],
    featured: false,
  },
  {
    slug: 'nanshi-shoubiao-xuanze-jiqiao',
    title: '成熟男士手表选择指南：从入门到进阶的品味进阶之路',
    excerpt: '手表是成熟男士最重要的配饰之一。不同场合应该佩戴什么样的手表？如何选择一块彰显品味又不失实用性的腕表？这篇指南为你一一解答。',
    content: `<p>手表之于成熟男性，如同珠宝之于优雅女士。一块合适的手表不仅能准确计时，更能无声地传达出佩戴者的品味、身份与生活态度。</p>
<h2>一、正装表的优雅选择</h2>
<p>正装表应当简约大方，表盘直径不宜过大，通常38-40mm最为合适。白色或银色的表盘搭配黑色或棕色皮带是最经典的选择。百达翡丽、江诗丹顿等品牌的简约款正装表是品味的象征，而浪琴、天梭等品牌则提供了高性价比的入门选择。</p>
<h2>二、运动表的实用之选</h2>
<p>对于日常休闲和运动场合，一块钢带运动表是最佳伙伴。劳力士潜航者系列、欧米茄海马系列都是经典中的经典。如果预算有限，帝舵、豪雅等品牌同样能够满足需求。</p>
<h2>三、手表与穿搭的搭配法则</h2>
<p>皮带手表适合搭配西装和正装，钢带手表则更加百搭。金色表壳搭配暖色系服装效果最佳，银色或钢色表壳则适合冷色系穿搭。记住一条黄金法则：皮带的颜色应当与您的腰带和皮鞋保持一致。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20closeup%20elegant%20shot%20of%20a%20luxurious%20classic%20leather%20strap%20watch%20on%20a%20mature%20mans%20wrist%2C%20wearing%20a%20well%20tailored%20navy%20suit%20cuff%2C%20sitting%20in%20a%20gentlemans%20club%20with%20dark%20wood%20paneling%20and%20warm%20ambient%20light%2C%20editorial%20product%20photography&width=1200&height=800&seq=article-watch-guide&orientation=landscape',
    category: '配饰推荐',
    categorySlug: 'peishi-tuijian',
    author: '王志远',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20distinguished%20Chinese%20man%20in%20his%2040s%20wearing%20a%20navy%20blazer%2C%20warm%20friendly%20expression%2C%20studio%20portrait%20with%20cream%20background%2C%20soft%20even%20lighting&width=200&height=200&seq=avatar-wang&orientation=squarish',
    date: '2026-07-22',
    readTime: '7分钟',
    tags: ['手表', '男士配饰', '腕表推荐', '正装表', '品味进阶'],
    featured: true,
  },
  {
    slug: 'xuejia-pinjian-chuxuezhe-zhinan',
    title: '中年男士雪茄入门指南：从选择到品鉴的完整教程',
    excerpt: '雪茄是成熟男性生活美学的重要组成部分。对于刚接触雪茄的朋友来说，如何选择、剪切、点燃和品鉴一支好雪茄？让我们一起走进雪茄的世界。',
    content: `<p>雪茄不仅是一种享受，更是一门关于耐心与品味的生活艺术。对于成熟男性来说，学会品鉴雪茄，意味着您已经掌握了慢生活的哲学。</p>
<h2>一、选择您的第一支雪茄</h2>
<p>对于初学者，建议从口感温和的雪茄开始。多米尼加和古巴的温和型雪茄是不错的选择，如蒙特克里斯托No.4或罗密欧与朱丽叶的Churchill系列。它们的口感顺滑，不会过于浓烈，非常适合入门。</p>
<h2>二、正确的剪切与点燃</h2>
<p>使用双刃雪茄剪或打孔器在雪茄头部切一个干净的开口。点燃时，使用丁烷打火机或雪松木条均匀加热雪茄脚部，旋转雪茄让火焰均匀接触，直到整个截面都呈现橘红色。注意不要将火焰直接接触雪茄——保持一定距离，让热量自然传导。</p>
<h2>三、品鉴的艺术</h2>
<p>雪茄不是用来吸入肺中的，而是让烟雾在口腔中停留，感受其复杂的风味层次。好的雪茄前段、中段和后段会呈现不同的风味变化。搭配一杯威士忌或朗姆酒，能够让品鉴体验更上一层楼。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sophisticated%20mature%20man%20enjoying%20a%20fine%20cigar%20in%20a%20classic%20leather%20armchair%20in%20a%20dimly%20lit%20gentlemans%20lounge%20with%20a%20glass%20of%20whiskey%2C%20smoke%20wisps%20curling%20elegantly%2C%20dark%20wood%20and%20leather%20interior%2C%20cinematic%20lighting%20with%20warm%20amber%20tones&width=1200&height=800&seq=article-cigar-guide&orientation=landscape',
    category: '生活美学',
    categorySlug: 'shenghuo-meixue',
    author: '陈建民',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20stylish%20Chinese%20man%20in%20his%2030s%20with%20tortoiseshell%20glasses%2C%20wearing%20a%20brown%20leather%20jacket%2C%20confident%20smile%2C%20studio%20portrait%20with%20warm%20neutral%20background&width=200&height=200&seq=avatar-chen&orientation=squarish',
    date: '2026-07-18',
    readTime: '9分钟',
    tags: ['雪茄', '生活美学', '品鉴指南', '绅士生活', '威士忌'],
    featured: false,
  },
  {
    slug: 'zhongnian-nanshi-hufa-biyou',
    title: '中年男士护肤必修课：简单有效的日常护肤方案',
    excerpt: '护肤不是女性的专利。随着年龄增长，男性皮肤同样需要精心呵护。这里有一套简单易行的日常护肤方案，帮助您保持清爽干净的形象。',
    content: `<p>许多中年男士对护肤存在误解，认为这是一件过于女性化的事情。事实上，良好的皮肤状态是个人形象的重要组成部分，它能让您看起来更加精神饱满、自信从容。</p>
<h2>一、基础清洁是第一步</h2>
<p>每天早晚使用温和的男士洁面产品清洁面部，这是护肤的最基本也是最关键的步骤。选择含有水杨酸或竹炭成分的洁面产品，能够有效清洁毛孔，预防黑头和粉刺。</p>
<h2>二、保湿不能忽视</h2>
<p>随着年龄增长，皮肤的水分流失速度加快。选择一款质地轻盈、不油腻的男士保湿乳液，每天早晚洁面后使用，能够有效改善皮肤干燥和细纹问题。</p>
<h2>三、防晒是抗衰老的关键</h2>
<p>紫外线是导致皮肤老化的最主要原因。建议选择SPF30以上、质地清爽的防晒产品，出门前15分钟涂抹。即使在秋冬季节和阴天，防晒同样不可忽视。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mature%20handsome%20man%20applying%20skincare%20product%20in%20a%20bright%20modern%20bathroom%20with%20marble%20countertop%2C%20clean%20minimalist%20aesthetic%2C%20fresh%20morning%20light%20streaming%20through%20window%2C%20lifestyle%20photography%20with%20warm%20neutral%20tones&width=1200&height=800&seq=article-skincare&orientation=landscape',
    category: '护肤健康',
    categorySlug: 'hufa-jiankang',
    author: '李博文',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20friendly%20Chinese%20man%20in%20his%2040s%20with%20salt%20and%20pepper%20hair%2C%20wearing%20a%20casual%20linen%20shirt%2C%20warm%20smile%2C%20outdoor%20portrait%20with%20soft%20natural%20light&width=200&height=200&seq=avatar-li&orientation=squarish',
    date: '2026-07-15',
    readTime: '5分钟',
    tags: ['男士护肤', '中年护肤', '日常护理', '防晒', '保湿'],
    featured: false,
  },
  {
    slug: 'pijiu-zhishi-changjian-wuqu',
    title: '绅士必备皮具知识：皮带、钱包与公文包的选择误区',
    excerpt: '一条好皮带、一个精致钱包、一只经典公文包，这些皮具是成熟男士身份的名片。但很多人在选择时存在误区，让我们来看看如何正确选择这些必备皮具。',
    content: `<p>皮具之于绅士，如同珠宝之于淑女。高质量的皮具不仅能陪伴您多年，更能随着时间流逝而展现出独特的韵味。但在选择皮具时，许多男士存在一些常见的认知误区。</p>
<h2>一、皮带的正确选择</h2>
<p>最常见的误区是认为越贵的皮带越好。事实上，选择皮带首先要看皮革材质和五金件的质量，而非品牌价格。全粒面牛皮是最佳选择，它保留了皮革的天然纹理和强度。皮带的宽度应当与您的体型相称，颜色应与鞋子保持一致。</p>
<h2>二、钱包的品味选择</h2>
<p>一个鼓鼓囊囊塞满各种卡片和收据的钱包，会严重破坏您的整体形象。长款钱包适合放在公文包中使用，日常携带建议选择简洁的双折款。选择深棕色或黑色的植鞣皮革，它会在使用过程中形成独特的包浆，这是属于您个人的独特印记。</p>
<h2>三、公文包的经典之选</h2>
<p>在商务场合，一只精致的公文包能够让您立即赢得尊重。经典英式翻盖公文包是最不会出错的选择。选择深棕色马鞍皮或黑色小牛皮，搭配黄铜五金件，永不过时。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20luxurious%20mens%20leather%20accessories%20including%20a%20vintage%20brown%20leather%20briefcase%2C%20classic%20belt%20and%20wallet%20arranged%20on%20a%20rich%20dark%20wooden%20desk%2C%20warm%20ambient%20lighting%20from%20a%20desk%20lamp%2C%20editorial%20product%20photography%20with%20elegant%20composition&width=1200&height=800&seq=article-leather&orientation=landscape',
    category: '配饰推荐',
    categorySlug: 'peishi-tuijian',
    author: '王志远',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20distinguished%20Chinese%20man%20in%20his%2040s%20wearing%20a%20navy%20blazer%2C%20warm%20friendly%20expression%2C%20studio%20portrait%20with%20cream%20background%2C%20soft%20even%20lighting&width=200&height=200&seq=avatar-wang&orientation=squarish',
    date: '2026-07-10',
    readTime: '7分钟',
    tags: ['皮具', '皮带', '钱包', '公文包', '绅士配饰'],
    featured: false,
  },
  {
    slug: 'weishiji-pinjian-ru-men',
    title: '威士忌品鉴入门：成熟男士不可不知的烈酒文化',
    excerpt: '威士忌被称为\"生命之水\"，是绅士社交场合中不可或缺的饮品。了解威士忌的基本知识，不仅能让您在社交场合游刃有余，更能体会到这门古老酿造艺术背后的深厚文化。',
    content: `<p>威士忌的世界博大精深，从苏格兰单一麦芽到日本调和威士忌，每一种都有其独特的风味和故事。对于初入门的成熟男士来说，了解以下几个方面的知识将让您快速成为朋友圈中的品鉴达人。</p>
<h2>一、威士忌的主要分类</h2>
<p>威士忌按产地可分为苏格兰威士忌、爱尔兰威士忌、美国波本威士忌、日本威士忌等。其中苏格兰单一麦芽威士忌因其复杂多变的风味而备受推崇。麦卡伦、格兰菲迪、拉弗格等品牌是入门的不错选择。</p>
<h2>二、正确的品鉴方法</h2>
<p>品鉴威士忌时，首先观察其色泽，从浅金色到深琥珀色代表了不同的陈年时间和橡木桶类型。然后轻轻摇晃酒杯，闻其香气，感受其中蕴含的果香、花香、烟熏或泥煤等不同风味。最后小口品尝，让酒液在口腔中停留数秒，体会其层次分明的口感变化。</p>
<h2>三、威士忌与食物的搭配</h2>
<p>威士忌与食物的搭配是一门精妙的艺术。烟熏风味的艾雷岛威士忌与生蚝是绝配，甜美的雪莉桶威士忌则与黑巧克力相得益彰。在雪茄时间，一杯浓郁的单一麦芽更是不可或缺的伴侣。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20crystal%20glass%20of%20amber%20whisky%20on%20a%20dark%20wooden%20table%20beside%20a%20decanter%2C%20in%20a%20classic%20study%20room%20with%20leather%20books%20and%20warm%20fireplace%20glow%2C%20rich%20golden%20lighting%2C%20luxurious%20and%20inviting%20atmosphere%2C%20editorial%20photography&width=1200&height=800&seq=article-whisky-guide&orientation=landscape',
    category: '生活美学',
    categorySlug: 'shenghuo-meixue',
    author: '陈建民',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20stylish%20Chinese%20man%20in%20his%2030s%20with%20tortoiseshell%20glasses%2C%20wearing%20a%20brown%20leather%20jacket%2C%20confident%20smile%2C%20studio%20portrait%20with%20warm%20neutral%20background&width=200&height=200&seq=avatar-chen&orientation=squarish',
    date: '2026-07-05',
    readTime: '8分钟',
    tags: ['威士忌', '品鉴指南', '烈酒文化', '绅士社交', '生活美学'],
    featured: true,
  },
  {
    slug: 'qiuji-nanshi-diechuan-jichu',
    title: '秋季男士叠穿技巧：层次感穿搭让您温度与风度并存',
    excerpt: '秋季是展现穿搭功力最好的季节。合理运用叠穿技巧，不仅能够应对温差变化，更能创造出丰富的视觉层次。掌握这些叠穿法则，让您的秋季穿搭更加出彩。',
    content: `<p>叠穿是成熟男士穿搭中最高级的技巧之一。它不仅能够灵活应对秋季多变的天气，更能通过不同单品的组合，创造出独一无二的个人风格。</p>
<h2>一、叠穿的基本法则</h2>
<p>内层贴身、中层保暖、外层防风——这是叠穿的黄金三角法则。内层选择轻薄的棉质或美利奴羊毛T恤，中层选择牛津纺衬衫或轻薄针织衫，外层则可以是西装外套、风衣或休闲夹克。</p>
<h2>二、色彩搭配的艺术</h2>
<p>叠穿时颜色不宜过多，建议控制在三个主色以内。由内到外，颜色可以由浅到深，营造出渐进的层次感。大地色系（棕色、卡其、橄榄绿）和经典中性色（灰、白、藏青）是最安全也最显品味的选择。</p>
<h2>三、经典叠穿组合推荐</h2>
<p>白T恤 + 牛仔衬衫 + 深色西装外套，搭配深色牛仔裤和棕色乐福鞋，这是一套永不过时的秋季造型。或者选择高领毛衣 + 灯芯绒夹克 + 羊毛大衣，打造出温暖复古的绅士形象。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stylish%20mature%20man%20wearing%20layered%20autumn%20outfit%20with%20white%20t-shirt%20denim%20shirt%20and%20grey%20blazer%2C%20standing%20on%20a%20leafy%20city%20street%20in%20golden%20hour%2C%20warm%20autumn%20colors%2C%20editorial%20street%20style%20photography%20with%20natural%20lighting&width=1200&height=800&seq=article-layering&orientation=landscape',
    category: '休闲日常',
    categorySlug: 'xiuxian-riang',
    author: '李博文',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20friendly%20Chinese%20man%20in%20his%2040s%20with%20salt%20and%20pepper%20hair%2C%20wearing%20a%20casual%20linen%20shirt%2C%20warm%20smile%2C%20outdoor%20portrait%20with%20soft%20natural%20light&width=200&height=200&seq=avatar-li&orientation=squarish',
    date: '2026-06-30',
    readTime: '6分钟',
    tags: ['秋季穿搭', '叠穿技巧', '层次感', '男士搭配', '季节穿搭'],
    featured: false,
  },
  {
    slug: 'zhongnian-jianshen-rumen',
    title: '中年男士健身入门指南：保持体态的实用训练方案',
    excerpt: '保持良好的体态是穿搭好看的基础。对于工作繁忙的中年男士来说，如何高效地保持身材？这套简单可行的训练方案，帮助您在不占用太多时间的情况下维持健康体魄。',
    content: `<p>健康的身体是一切的基础，而良好的体态更是穿搭出彩的前提。中年男士面临代谢减缓、肌肉流失等问题，适当的健身训练不仅能够保持身材，更能提升整体精神状态。</p>
<h2>一、力量训练是核心</h2>
<p>随着年龄增长，肌肉量每年以1-2%的速度流失。每周进行2-3次力量训练，重点锻炼胸、背、腿三大肌群，能够有效延缓肌肉流失。深蹲、俯卧撑、引体向上是最基础也最有效的三个动作。</p>
<h2>二、有氧运动不可少</h2>
<p>每周安排2次30-45分钟的有氧运动，如快走、慢跑、游泳或骑行。有氧运动能够提升心肺功能，帮助控制体脂率，让您的西装穿起来更加合身。</p>
<h2>三、饮食与恢复同样重要</h2>
<p>健身效果三分靠练七分靠吃。保证充足的蛋白质摄入（每公斤体重1.2-1.6克），多吃蔬菜水果，控制精制碳水和糖分的摄入。同时确保每晚7-8小时的优质睡眠，这是身体恢复的关键。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fit%20mature%20man%20doing%20strength%20training%20with%20dumbbells%20in%20a%20modern%20well%20equipped%20gym%2C%20focused%20expression%2C%20natural%20light%20from%20large%20windows%2C%20clean%20minimalist%20fitness%20aesthetic%2C%20lifestyle%20photography&width=1200&height=800&seq=article-fitness&orientation=landscape',
    category: '护肤健康',
    categorySlug: 'hufa-jiankang',
    author: '李博文',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20friendly%20Chinese%20man%20in%20his%2040s%20with%20salt%20and%20pepper%20hair%2C%20wearing%20a%20casual%20linen%20shirt%2C%20warm%20smile%2C%20outdoor%20portrait%20with%20soft%20natural%20light&width=200&height=200&seq=avatar-li&orientation=squarish',
    date: '2026-06-25',
    readTime: '7分钟',
    tags: ['健身', '中年健康', '力量训练', '体型管理', '健康生活'],
    featured: false,
  },
  {
    slug: 'nanshi-jinkuang-yanjing-xuanze',
    title: '男士眼镜框型选择指南：根据脸型挑选最合适的镜框',
    excerpt: '一副合适的眼镜能够瞬间提升您的气质与形象。不同脸型适合什么样的镜框？如何选择既实用又时尚的眼镜？这篇指南帮助您找到最适合自己的那一副。',
    content: `<p>眼镜不仅是矫正视力的工具，更是成熟男士面部最重要的装饰品。一副恰到好处的眼镜能够修饰脸型、突出气质，甚至成为您的标志性特征。</p>
<h2>一、根据脸型选择镜框</h2>
<p>圆脸适合方形或矩形的镜框，能够增加面部的线条感；方脸则适合圆形或椭圆形的镜框，柔化面部棱角；长脸适合较宽的镜框，在视觉上缩短脸长；心形脸适合底部较宽的镜框，平衡额头与下巴的比例。</p>
<h2>二、材质与颜色的选择</h2>
<p>金属镜框（钛合金、不锈钢）轻盈耐用，适合商务场合；板材镜框（醋酸纤维）复古时尚，适合休闲搭配；玳瑁色是永远不会出错的经典选择，而金色和银色则是提升精致感的利器。</p>
<h2>三、2026年流行趋势</h2>
<p>今年复古圆框和透明板材框非常流行。对于成熟男士来说，选择经典款式往往比追逐潮流更加明智。一副做工精良的经典款眼镜，可以使用多年而不显过时。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20distinguished%20mature%20man%20wearing%20classic%20tortoiseshell%20eyeglasses%2C%20sitting%20at%20a%20modern%20wooden%20desk%20reading%20a%20book%2C%20warm%20ambient%20light%20from%20a%20desk%20lamp%2C%20refined%20study%20atmosphere%2C%20editorial%20portrait%20photography&width=1200&height=800&seq=article-glasses&orientation=landscape',
    category: '配饰推荐',
    categorySlug: 'peishi-tuijian',
    author: '王志远',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20distinguished%20Chinese%20man%20in%20his%2040s%20wearing%20a%20navy%20blazer%2C%20warm%20friendly%20expression%2C%20studio%20portrait%20with%20cream%20background%2C%20soft%20even%20lighting&width=200&height=200&seq=avatar-wang&orientation=squarish',
    date: '2026-06-20',
    readTime: '5分钟',
    tags: ['眼镜', '镜框选择', '脸型搭配', '男士配饰', '复古眼镜'],
    featured: false,
  },
  {
    slug: 'chengshu-nanshi-xiangshui',
    title: '成熟男士香水指南：不同场合的香氛选择与使用技巧',
    excerpt: '香水是看不见的衣着，是成熟男士留给他人最独特的印象。如何选择适合自己的香水？不同场合应该喷什么样的香？正确的使用方法是怎样的？',
    content: `<p>气味是记忆的载体，一款合适的香水能让他人在第一时间记住您。对于成熟男士来说，香水不是可有可无的点缀，而是整体形象的重要组成部分。</p>
<h2>一、香水的基本分类</h2>
<p>香水按浓度可分为香精、香水、淡香水和古龙水。按香调可分为木质调、柑橘调、东方调、馥奇调等。成熟男士建议选择木质调或东方调的香水，它们更加沉稳内敛，正如经历岁月沉淀的男人。</p>
<h2>二、不同场合的香氛选择</h2>
<p>商务场合选择清新淡雅的柑橘调或绿叶调香水，如爱马仕的 Terre d'Hermès；约会时选择温暖性感的木质调或琥珀调，如迪奥的 Sauvage；正式晚宴则可以选择深邃复杂的东方调，如汤姆·福特的 Tobacco Vanille。</p>
<h2>三、正确的使用方法</h2>
<p>香水应喷在脉搏跳动处——手腕内侧、耳后、颈部和胸口。不要摩擦手腕，这会破坏香水的分子结构。记住\"少即是多\"的原则，让香味若隐若现，才能给人留下优雅的印象。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20elegant%20mens%20fragrance%20bottles%20on%20a%20marble%20vanity%20tray%2C%20warm%20ambient%20lighting%2C%20refined%20masculine%20aesthetic%2C%20dark%20wood%20background%2C%20editorial%20product%20photography%20with%20luxurious%20composition&width=1200&height=800&seq=article-fragrance&orientation=landscape',
    category: '生活美学',
    categorySlug: 'shenghuo-meixue',
    author: '陈建民',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20stylish%20Chinese%20man%20in%20his%2030s%20with%20tortoiseshell%20glasses%2C%20wearing%20a%20brown%20leather%20jacket%2C%20confident%20smile%2C%20studio%20portrait%20with%20warm%20neutral%20background&width=200&height=200&seq=avatar-chen&orientation=squarish',
    date: '2026-06-15',
    readTime: '6分钟',
    tags: ['香水', '男士香氛', '木质调', '使用技巧', '个人形象'],
    featured: false,
  },
];

export function getFeaturedArticles(): Article[] {
  return articles.filter((a) => a.featured);
}

export function getArticlesByCategory(categorySlug: string): Article[] {
  return articles.filter((a) => a.categorySlug === categorySlug);
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export function getRelatedArticles(currentSlug: string, categorySlug: string, limit: number = 3): Article[] {
  return articles
    .filter((a) => a.slug !== currentSlug && a.categorySlug === categorySlug)
    .slice(0, limit);
}